import * as Types from "../schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddResearchMutationVariables = Types.Exact<{
  upload_id: Types.Scalars["uuid"];
  s3_key: Types.Scalars["String"];
  s3_level: Types.Scalars["String"];
  public_url?: Types.Maybe<Types.Scalars["String"]>;
  description: Types.Scalars["String"];
  research_date?: Types.Maybe<Types.Scalars["String"]>;
  research_title?: Types.Maybe<Types.Scalars["String"]>;
}>;

export type AddResearchMutation = { __typename?: "mutation_root" } & {
  insert_research?: Types.Maybe<
    { __typename?: "research_mutation_response" } & {
      returning: Array<
        { __typename?: "research" } & Pick<Types.Research, "id">
      >;
    }
  >;
};

export const AddResearchDocument = gql`
  mutation AddResearch(
    $upload_id: uuid!
    $s3_key: String!
    $s3_level: String!
    $public_url: String
    $description: String!
    $research_date: String
    $research_title: String
  ) {
    insert_research(
      objects: {
        research_date: $research_date
        research_title: $research_title
        upload: {
          data: {
            id: $upload_id
            public_url: $public_url
            s3_key: $s3_key
            s3_level: $s3_level
            description: $description
          }
        }
      }
    ) {
      returning {
        id
      }
    }
  }
`;

export function useAddResearchMutation() {
  return Urql.useMutation<AddResearchMutation, AddResearchMutationVariables>(
    AddResearchDocument
  );
}
